export default __webpack_public_path__ + "static/media/ShopLocalIcon.59e43982.png";